import React, { useState } from 'react';

const TrackChannelModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setMessage({ 
        type: 'error', 
        text: 'Please enter your email address'
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    // In a real implementation, you would send this to your backend/email service
    // For now, we'll just show a success message
    setTimeout(() => {
      setLoading(false);
      setMessage({ 
        type: 'success', 
        text: 'Thank you for your interest! We\'ll reach out to you soon about channel tracking pricing and features.'
      });
      // Auto-close after 3 seconds
      setTimeout(() => {
        onClose();
        setEmail('');
        setMessage(null);
      }, 3000);
    }, 1000);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget && !loading) {
          onClose();
        }
      }}
    >
      <div
        style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginBottom: '8px', color: '#fff', fontSize: '24px', fontWeight: '600', fontFamily: 'Space Grotesk, sans-serif' }}>
          Track A Channel
        </h2>
        <p style={{ marginBottom: '24px', color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px', lineHeight: '1.5' }}>
          Unlock custom channel tracking and learn about pricing. Enter your email and we'll reach out to you.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px 16px',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                color: '#fff',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
              }}
            />
          </div>

          {message && (
            <div
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                marginBottom: '20px',
                backgroundColor: message.type === 'error' 
                  ? 'rgba(239, 68, 68, 0.15)' 
                  : 'rgba(34, 197, 94, 0.15)',
                border: `1px solid ${message.type === 'error' ? 'rgba(239, 68, 68, 0.3)' : 'rgba(34, 197, 94, 0.3)'}`,
                color: message.type === 'error' ? '#ef4444' : '#22c55e',
                fontSize: '14px',
                lineHeight: '1.5',
              }}
            >
              {message.text}
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '12px 24px',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backgroundColor: 'transparent',
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '14px',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                opacity: loading ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.color = '#fff';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                }
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !email.trim()}
              style={{
                padding: '12px 24px',
                borderRadius: '12px',
                border: 'none',
                backgroundColor: loading || !email.trim() ? 'rgba(72, 120, 255, 0.5)' : '#4878ff',
                color: '#fff',
                fontSize: '14px',
                fontWeight: '500',
                cursor: loading || !email.trim() ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!loading && email.trim()) {
                  e.target.style.backgroundColor = '#5a87ff';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && email.trim()) {
                  e.target.style.backgroundColor = '#4878ff';
                }
              }}
            >
              {loading ? 'Sending...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TrackChannelModal;

